import { ResolverTag } from '@ps/web-core-enums';
import classNames from 'clsx';
import { isUndefined } from 'lodash';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useOpenWindow from '@swf/core/hooks/useOpenWindow';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';

import type { Props as ButtonProps } from '../Button/Button';
import Button from '../Button/Button';

import {
  TXTWCL_Need_helpX_Visit_our_Help_Cent_ELL,
  TXTWCL_Set_your_deposit_limit_1,
  TXTWCL_Your_deposit_limit_2
} from './HelpSupportButton.messages.json';
import { button, helpButton } from './HelpSupportButton.scss';

interface Props extends ButtonProps {
  resolverTag?: ResolverTag;
  limitSet?: boolean;
}

const HelpSupportButton: React.FC<Props> = ({
  resolverTag = ResolverTag.HelpCenterDepositWithdrawal,
  className,
  limitSet = undefined
}) => {
  const openWindow = useOpenWindow({ resolverTag });
  const isEmbedded = useSelector(select.device.isEmbedded);
  const isMobileEmbedded = useSelector(select.device.isMobileEmbedded);
  const depositLimitPath = useSelector(select.account.getDepositLimitPath);
  const {
    data: { cmsHeaderAndGridLayout }
  } = useWizardContext();
  const {
    modal: { enqueue }
  } = useDispatch<Dispatch>();

  let buttonLabel;
  if (isUndefined(limitSet)) {
    buttonLabel = TXTWCL_Need_helpX_Visit_our_Help_Cent_ELL;
  } else {
    buttonLabel = limitSet ? TXTWCL_Your_deposit_limit_2 : TXTWCL_Set_your_deposit_limit_1;
  }

  const openRestrictDepositLimit = () => {
    isEmbedded
      ? window.starsweb?.app.execute('menu/requests/responsible-gaming/deposit-limit')
      : enqueue({ path: depositLimitPath });
  };

  const openWindowCheck = () => {
    isEmbedded ? window?.starsweb?.app?.execute?.(`help-center/${resolverTag}`) : openWindow();
  };

  return (
    <Button
      type="button"
      translation={buttonLabel}
      firstVariant="help"
      className={classNames(button, className, {
        [helpButton]: !isMobileEmbedded && cmsHeaderAndGridLayout
      })}
      onClick={() => (isUndefined(limitSet) ? openWindowCheck() : openRestrictDepositLimit())}
    />
  );
};

export default HelpSupportButton;
